import { Grid, Typography } from "@mui/material";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import {
  getCompliantSummaryByIdWoLoader,
  getPetAndAppointmentDetailsById,
  getPetsCompliantSummaryWoLoader,
} from "../../../redux/reducers/petSlice";
import { getRightSaluation } from "../../../util/function";
import CommonClinicPetDetails from "../../CommonScreens/CommonClinicPetDetails/CommonClinicPetDetails";
import UpdateRemarks from "../../CommonScreens/UpdateRemarks/UpdateRemarks";
import PetPharmacyProcedures from "../ClinicPetDetails/PatientWorkbook/PetPharmacyProcedures";

const PharmacyPetDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { appointment } = location.state || {};
  const [isVideoCallEnabled, setVideoCallEnabled] = useState(false);
  const [scrollable, setScrollable] = useState(true);
  const [inpatientId, setInpatientId] = useState(location?.state?.inpatientId);
  const [selectedTab, setSelectedTab] = useState("overView");
  const [allergyModOpen, setAllergyModOpen] = useState(false);
  const [remarksModVsble, setRemarksModVsble] = useState(false);
  const [posVisible, setPosVisible] = useState(false);
  const [createBillState, setCreateBillState] = useState({
    show: false,
    onOpen: null,
  });
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const appDet = reqDet?.appointment;
  const user = localStorage.getItem("user");
  const profile = user ? JSON.parse(user) : null;
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const clinicVets = useMemo(() => {
    if (!mandateDataRaw) return [];
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return Array.isArray(reqData?.vets) ? reqData.vets : [];
    } catch {
      return [];
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    dispatch(
      getPetAndAppointmentDetailsById({
        petId: appointment?.appoinment?.petId,
        url: `${appointment?.appoinment?.appointmentId ? `?appointmentId=${appointment?.appoinment?.appointmentId}` : ""}`,
      }),
    );
    dispatch(
      getPetsCompliantSummaryWoLoader(appointment?.appoinment?.appointmentId),
    );
  }, []);

  const onCloseRemarks = () => {
    setRemarksModVsble(false);
  };

  const handleViewSmmary = () => {
    if (!reqDet?.lastAppointmentId) return;
    dispatch(getCompliantSummaryByIdWoLoader(reqDet?.lastAppointmentId));
  };

  const handleCreateBillReady = useCallback((state) => {
    setCreateBillState(state ?? { show: false, onOpen: null });
  }, []);

  return (
    <>
      <CommonClinicPetDetails
        upcomingVisible={false}
        isVideoCallEnabled={isVideoCallEnabled}
        setVideoCallEnabled={setVideoCallEnabled}
        appointment={appointment}
        scrollable={scrollable}
        setSelectedTab={setSelectedTab}
        setInpatientId={setInpatientId}
        allergyModOpen={allergyModOpen}
        setAllergyModOpen={setAllergyModOpen}
        selectedTab={selectedTab}
        setScrollable={setScrollable}
      >
        {!posVisible ? (
          <>
            <Grid container className="ph2">
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="back-white p10 bs-margin"
              >
                <div className="flex-row">
                  <div
                    className="ph10pv3"
                    onClick={() => setSelectedTab("overView")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "overView"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Overview
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <div className="pat-top-con light-blue-back4 ph20 pv10 w100Per mtMin20">
              <div className="flex-row-ali-cen">
                <Typography className="fs12 blue-color font-bold">
                  Case ID - {appDet?.caseId}
                </Typography>
                <Typography className="blue-color fs12 font-medium ml15">
                  {appDet?.serviceType}
                </Typography>
                <Typography className="blue-color fs12 font-medium ml15">
                  {moment(new Date(appDet?.appointmentdateTime)).format(
                    "DD MMM YYYY, HH:mm",
                  )}
                </Typography>
                <Typography className="blue-color fs12 font-medium ml15">
                  {getRightSaluation(clinicVets, appDet?.doctorId)}
                  {appDet?.doctorName}
                </Typography>
                {reqDet?.lastVisitDate?.length > 0 ? (
                  appDet?.appointmentStatus?.toLowerCase() === "completed" &&
                  !appDet?.lock ? null : (
                    <Typography className="black fs12 font-medium ml15">
                      Last Visit{" "}
                      {moment(new Date(reqDet?.lastVisitDate)).format(
                        "DD, MMM YYYY",
                      )}
                    </Typography>
                  )
                ) : null}
                {reqDet?.lastAppointmentId ? (
                  appDet?.appointmentStatus?.toLowerCase() === "completed" &&
                  !appDet?.lock ? null : (
                    <Typography
                      className="blue-color fs12 txt-semi-bold ml15 underline cursor"
                      onClick={handleViewSmmary}
                    >
                      View Summary
                    </Typography>
                  )
                ) : null}
                {appDet?.appointmentStatus?.toLowerCase() === "completed" &&
                !appDet?.lock ? (
                  <>
                    <Typography className="black fs12 font-medium ml15">
                      Unlocked At{" "}
                      {moment(new Date(appDet?.unlockedAt)).format(
                        "DD MMM YYYY, HH:mm",
                      )}
                    </Typography>
                    {appDet?.unlockedBy ? (
                      <Typography className="black fs12 font-medium ml15">
                        Unlocked By{" "}
                        {getRightSaluation(clinicVets, appDet?.unlockedBy)
                          ? getRightSaluation(clinicVets, appDet?.unlockedBy)
                          : profile?.id === appDet?.unlockedBy
                            ? profile?.name
                            : ""}
                      </Typography>
                    ) : null}
                  </>
                ) : null}
                <div className="flex1-end">
                  {createBillState?.show ? (
                    <div className="w150Px">
                      <CustomButton
                        text="Create Bill"
                        smallBtn
                        onClick={() => createBillState?.onOpen?.()}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </>
        ) : null}
        <div className={posVisible ? "w100Per" : "scroll-80vh ph20"}>
          <PetPharmacyProcedures
            onPosVisibleChange={setPosVisible}
            onCreateBillReady={handleCreateBillReady}
          />
        </div>
      </CommonClinicPetDetails>
      {remarksModVsble ? (
        <UpdateRemarks
          remarksModVsble={remarksModVsble}
          onCloseRemarks={onCloseRemarks}
          remarks={appDet?.remarks}
          notes={appDet?.notes}
          id={appDet?.appointmentId}
        />
      ) : null}
    </>
  );
};

export default PharmacyPetDetails;
